import { put, call, select, takeLatest, all } from "redux-saga/effects";
import * as epic from "../api/epicApi";
import * as types from "../constants/actionTypes";
import { logAPI } from "../api/andyliticsApi";

export default function* epicSaga() {
    yield takeLatest(types.EPIC_DEPT_LIST_GET_START, loadDepartmentList);
}

export function* loadDepartmentList(payload) {
    try {
        const start = new Date();
        const stateEpic = yield select((state) => state.epic);
        const stateDomain = yield select((state) => state.domain);

        if (stateEpic && stateEpic.departmentList && stateEpic.departmentList.length > 0) {
            // exit out, don't reload
            // console.log("Skipping load since we already have the list");
        }
        else {
            let departmentList = [];
            try {
                logAPI("Saga.Epic.GetDepartmentList", start, null);
                const list = yield call(epic.getEpicDepartmentList, stateDomain.t);
                departmentList = list.departments;
                yield put({ type: types.EPIC_DEPT_LIST_SET_DATA, departmentList });
                yield put({ type: types.EPIC_DEPT_LIST_GET_END });
                logAPI("Saga.Epic.GetDepartmentList.Success", start, null, { totalDepartments: departmentList ? departmentList.length : null });
            }
            catch (E) {
                console.error(E);
                logAPI("Saga.Epic.GetDepartmentList.Failure", start, null, E);
                yield put({ type: types.EPIC_DEPT_LIST_SET_DATA, departmentList });
                yield put({ type: types.EPIC_DEPT_LIST_GET_END, error: E });
            }
        }
    }
    catch (E) {
        console.error(E);
    }
}